import { TabularTypeAdapter } from 'app/model/adapters/dataflow/formatAdapters/tabular-type.adapter';
import { DataFlowDSLAdapterRegistry, Metamodel, Owned } from 'shell-models-lib';
import { TeamDeskSettings } from 'app/model/dataflow/dataset-settings/team-desk-settings';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(TeamDeskSettings)
})
export class TeamDeskAdapter extends TabularTypeAdapter {
    public async toSourceDSL(setting: TeamDeskSettings): Promise<string[]> {
        const props = [];
        props.push(`store: '${DatasetFormatType.TeamDesk}'`);
        props.push(`format: 'rest'`);
        if (setting.schemaName.expression) {
            props.push(`table: ${DataFlowExpressionUtils.wrapExpressionConfigValue(setting.schemaName)}`);
        }
        if (setting.tableName.expression) {
            props.push(`view: ${DataFlowExpressionUtils.wrapExpressionConfigValue(setting.tableName)}`);
        }
        return props;
    }

    public async toSourceModel(
        owner: DataFlowSource,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<TeamDeskSettings> {
        const setting = (await super.toSourceModel(owner, configs, handledConfigs)) as TeamDeskSettings;
        if (configs.has('table')) {
            setting.schemaName = DataFlowExpressionUtils.unwrapExpressionConfigValue(configs.get('table'), owner);
            handledConfigs.push('table');
        }
        if (configs.has('view')) {
            setting.tableName = DataFlowExpressionUtils.unwrapExpressionConfigValue(configs.get('view'), owner);
            handledConfigs.push('view');
        }
        return setting;
    }

    protected _generateSetting(owner: DataFlowSource | DataFlowSink): TeamDeskSettings {
        const setting = Owned.create<TeamDeskSettings>(TeamDeskSettings.MODEL, owner);
        setting.initialize(undefined);
        return setting;
    }
}
